import { EventContextProvider } from "@codat/analytics";
import { OrchardProvider } from "@codat/orchard-ui";
import { ConfigProvider, useConfig } from "contexts/ConfigContext";
import { DemoModeProvider } from "contexts/DemoModeContext";
import { BrowserRouter } from "react-router-dom";

import { MobileWarningOverlay } from "components/MobileWarningOverlay/MobileWarningOverlay";

import styles from "./App.module.css";
import AppRouter from "./AppRouter";

export const App = () => {
  return (
    <div className={styles.app}>
      <BrowserRouter>
        <OrchardProvider appId="app-link">
          <ConfigProvider>
            <DemoModeProvider>
              <EventTrackingWrapper>
                <MobileWarningOverlay />
                <AppRouter />
              </EventTrackingWrapper>
            </DemoModeProvider>
          </ConfigProvider>
        </OrchardProvider>
      </BrowserRouter>
    </div>
  );
};

const EventTrackingWrapper = ({ children }: React.PropsWithChildren) => {
  const config = useConfig();

  const poweredByCodat: string | boolean =
    config?.state?.data?.showPoweredByCodat ?? "N/A";

  return (
    <EventContextProvider data={{ poweredByCodat }}>
      {children}
    </EventContextProvider>
  );
};
